<template>
  <Modal v-model="channelModal" :title="$t('key1000236')" :mask-closable="false" @on-visible-change="channelModalChange">
    <Form :label-width="120" @submit.native.prevent>
      <Row type="flex">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1000237')">
            <Select v-model="selectProvider" @on-change="ChangeSelectProvider" filterable>
              <Option v-for="item in selectProviderList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1000238')">
            <Select v-model="logisticsChannel" filterable @on-change="ChangeLogisticsChannel">
              <Option v-for="item in logisticsChannelList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <div style="text-align: center;">
        <Button type="primary" @click="saveChannelBtn">{{ $t('key1000111') }}</Button>
        <Button @click="channelModal=false">{{ $t('key1000112') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: "channelReferenceModal",
  mixins: [Mixin],
  data() {
    return {
      channelModal: false,
      selectProvider: null,
      selectProviderList: [],
      logisticsChannel: null,
      logisticsChannelList: [],
      selectType: null,
    };
  },
  methods: {
    // 获取对应物流商的物流渠道
    ChangeSelectProvider(val) {
      this.logisticsChannelList = [];
      if (val) {
        this.axios.get(api.get_enableShippingMethods + '?carrierId=' + val).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            if (data.length > 0) {
              data.map((item) => {
                this.logisticsChannelList.push({
                  id: item.shippingMethodId,
                  arriveableType: item.arriveableType,
                  name: item.carrierShippingMethodName
                });
              });
            }
          }
        });
      }
    },
    // 获取选取其他渠道对应的派送范围
    ChangeLogisticsChannel(id) {
      if (this.logisticsChannelList.length > 0) {
        this.logisticsChannelList.map((item) => {
          if (item.id === id) {
            this.selectType = item.arriveableType;
          }
        });
      }
    },
    // 引用其他物流渠道的确定按钮
    saveChannelBtn() {
      let v = this;
      if (v.logisticsChannel !== null) {
        v.axios.get(api.get_carrierShippingMethodPrice + '?shippingMethodId=' + v.logisticsChannel).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.datas.carrierShippingMethodPriceModelZones;
            v.$emit('saveChannel', {
              arriveableType: v.selectType,
              list: data
            });
            v.channelModal = false;
          }
        });
      } else {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000235'));
        return false;
      }
    },
    // 监听弹窗
    channelModalChange(value) {
      if (!value) {
        this.selectType = null;
        this.selectProvider = null;
        this.logisticsChannel = null;
      }
    }
  }
};
</script>

<style scoped>

</style>
